// Copyright (C) 2020 One More Game - All Rights Reserved
// Unauthorized copying of any files within this project, via any medium, is strictly prohibited
// Proprietary and confidential

import React from "react"
import Img, { FluidObject } from "gatsby-image"
import Slider from "react-slick"
import "slick-carousel/slick/slick.scss"
import "slick-carousel/slick/slick-theme.scss"

interface SliderItemProps {
  file: FluidObject
  alt: string
}

const SliderItem: React.FC<SliderItemProps> = ({
  file,
  alt,
}: SliderItemProps) => {
  return <Img key={file.src} fluid={file} alt={alt} />
}

interface Props {
  images: SliderItemProps[]
}

const FullWidthImageSlider: React.FC<Props> = ({ images }: Props) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    autoplaySpeed: 3000,
    fadeIn: false,
    autoplay: true,
    pauseOnHover: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }

  return (
    <Slider {...settings}>
      {images.map(image => (
        <SliderItem key={image.file.src} {...image} />
      ))}
    </Slider>
  )
}

export default FullWidthImageSlider
